/**
 * ThemeToggle — Bouton de basculement des 3 modes (light/dark/system).
 *
 * Design institutionnel : icône seule, ronde, discrète.
 * Un click cycle entre les 3 modes ; tooltip explicatif.
 */
import React from "react";
import { Sun, Moon, Monitor } from "lucide-react";
import useTheme from "@/lib/useTheme";


const ICONS = { light: Sun, dark: Moon, system: Monitor };
const LABELS = {
  light: "Mode clair (papier)",
  dark: "Mode sombre institutionnel",
  system: "Suit le système",
};


export default function ThemeToggle({ className = "" }) {
  const { mode, cycle } = useTheme();
  const Icon = ICONS[mode] || Sun;

  return (
    <button
      type="button"
      onClick={cycle}
      className={`inline-flex items-center justify-center w-9 h-9 rounded-full border border-border/60 bg-background hover:bg-muted/50 transition-all active:scale-95 ${className}`}
      title={LABELS[mode]}
      aria-label={LABELS[mode]}
      data-testid="theme-toggle"
      data-mode={mode}
    >
      <Icon className="w-4 h-4 text-ink" />
    </button>
  );
}
